import React from 'react'
import { NavLink } from 'react-router-dom'

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export const BreadcrumbItem = ({
    to=null,
    bullet=null,
    muted=null,
    title=""
}) => {
  return (
     bullet==="true" ?
        <li id="" className="breadcrumb-item">
            <span className="bullet bg-gray-300 w-5px h-2px" />
        </li>
        :
        <li id="" className={muted==="true" ? 'breadcrumb-item text-muted' : 'breadcrumb-item'}>
            {to!=null ? 
            <NavLink className="breadcrumb-item text-dark" to={to}>{title}</NavLink>
            : 
            <span className="text-muted text-hover-primary">
            {title}
            </span>}
        </li>    
  )
}
